
export default {
  name: 'VRangeCalculator',

  props: {
    valueList: {
      type: Array,
      default: () => [],
    },
    step: {
      type: Number,
    },
    currentValueProps: {
      type: Number,
      required: false,
    },
    label: {
      type: String,
      default: '',
    },
    isNotInteger: {
      type: Boolean,
      required: false,
    },
    valueName: {
      type: String,
      default: '',
    },
  },
  components: {
  },
  emits: [
    'changeCurrentPaymentInfo',
  ],
  data() {
    return {
      currentValueRange: 40,
      rangeMinMax: {
        valueMin: undefined,
        valueMax: undefined,
      },
      currentValueInput: '',
    }
  },
  methods: {
    replaceSpacingString: function (str) {
      return String(str).replace(/\s/g, '');
    },
    formatBound: function (value) {
      if (value == null) {
        return '';
      }
      if (!this.isNotInteger) {
        return this.$numberFormat(value, 0);
      }
      const rounded = Math.round(Number(value) * 100) / 100;
      return String(rounded).replace('.', ',');
    },
    formatNumber: function (num) {
      if (this.isNotInteger) {
        return num.toLocaleString('ru-RU', { 
          minimumFractionDigits: 0, 
          maximumFractionDigits: 2 
        });
      } else {
        return Math.floor(num).toLocaleString('ru-RU');
      }
    },
    onEmitValue: function () {
      this.$emit('changeCurrentPaymentInfo', {
        slug: this.valueName,
        value: this.currentValueRange,
      })
    },
    changeRange: function () {
      this.onEmitValue();
    },
    onChangeInput: function (event) {
      const {value} = (event.target);

      let valueClear = Number.parseFloat((value || '').replace(/\s/g, ''));
      if (Number.isNaN(valueClear)) {
        valueClear = this.rangeMinMax.valueMin || 0;
      }

      if (this.rangeMinMax.valueMax != null && valueClear > this.rangeMinMax.valueMax) {
        this.currentValueInput = this.formatNumber(this.rangeMinMax.valueMax);
        this.currentValueRange = this.rangeMinMax.valueMax;
      } else if (this.rangeMinMax.valueMin != null && valueClear < this.rangeMinMax.valueMin) {
        this.currentValueInput = this.formatNumber(this.rangeMinMax.valueMin);
        this.currentValueRange = this.rangeMinMax.valueMin;
      } else {
        this.currentValueRange = valueClear;
      }

      this.onEmitValue();
    },
    optionsInput: function () {
      return {
        preProcess: (val) => {
          // Убираем все пробелы и форматируем число
          return val ? val.replace(/\s/g, '') : '';
        },
        postProcess: (val) => {
          if (!val) {
            return this.rangeMinMax.valueMin || '';
          }
          // Форматируем число с разделителями разрядов
          const num = parseFloat(val.replace(/\s/g, ''));
          if (isNaN(num)) return '';
          
          if (this.isNotInteger) {
            return num.toLocaleString('ru-RU', { 
              minimumFractionDigits: 0, 
              maximumFractionDigits: 2 
            });
          } else {
            return Math.floor(num).toLocaleString('ru-RU');
          }
        }
      }
    },
    initRange: function () {
      if (this.currentValueProps == null) {
        return;
      }
      if (this.valueList && this.valueList.length) {
        this.rangeMinMax.valueMin = Math.min.apply(null, this.valueList);
        this.rangeMinMax.valueMax = Math.max.apply(null, this.valueList);
      }

      let next = Number(this.replaceSpacingString(this.currentValueProps));
      if (!Number.isFinite(next)) {
        return;
      }
      const min = this.rangeMinMax.valueMin;
      const max = this.rangeMinMax.valueMax;
      if (min != null && next < min) {
        next = min;
      }
      if (max != null && next > max) {
        next = max;
      }

      this.currentValueRange = next;
      this.currentValueInput = this.formatNumber(next);
      if (next !== this.currentValueProps) {
        this.onEmitValue();
      }
    },
    prepareDecimalsNumbers: function (item) {
      return Number(item * 100).toFixed(2)
    },

    // sliderRangeFormater: function (value) { // подключить для форматирования десятичных цифр (если требуется) и включить во VueRange :formatter="sliderRangeFormater"
    //   if (!this.isNotInteger) {
    //     return value
    //   }
    //   return this.prepareDecimalsNumbers(value)
    // },
  },
  watch: {
    'currentValueRange': function() {
      this.currentValueInput = this.formatNumber(this.currentValueRange)
    },
    'currentValueProps': function() {
      if (this.currentValueProps != null) {
        this.initRange();
      }
    },
    'valueList': function() {
      this.initRange();
    }
  },
  mounted: function() {
    this.$nextTick(() => {
      this.initRange();
    })
  }
}
